import { render } from "./index.vue?vue&type=template&id=3b56247e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3b56247e&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=3b56247e&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b56247e"],['__file',"src/views/CadastroTarefas/components/ModalPeriodoVigencia/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b56247e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b56247e', __exports__)) {
    console.log('reload')
    api.reload('3b56247e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3b56247e&scoped=true", () => {
    console.log('re-render')
    api.rerender('3b56247e', render)
  })

}


export default __exports__